import { testimonials } from "@/mocks/dramas";

export default function Testimonials() {
  return (
    <section className="bg-background-100/60 py-16 md:py-20" aria-labelledby="voice-title">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-[0.3em] text-accent-400">读者口碑</span>
          <h2 id="voice-title" className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            追剧的人，这样评价黑料剧场
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            我们不追热点排序，只把「为什么值得看」讲清楚，让你在点开之前心里有数。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-6"
            >
              <div className="flex items-center gap-1 text-accent-500" aria-label="五星好评">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-800">
                「{item.text}」
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-accent-400">
                  {item.name.slice(0, 1)}
                </span>
                <span className="text-sm">
                  <span className="block font-label text-foreground-950">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}